export default __webpack_public_path__ + "static/media/video.2d9d57d7.svg";